<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表
    -->
  <div class="user">
    <!--添加管理员-->
    <div class="common-level-rail">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/auth/user/add'">添加管理员</el-button></el-form-item>
        <el-form-item label="用户名" style="margin-left: 50px"><el-input v-model="formInline.user_name" placeholder="请输入用户名或姓名"></el-input></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shop_user_id" label="管理员ID"></el-table-column>
          <el-table-column prop="name" label="用户名/姓名">
            <template slot-scope="scope">
              {{scope.row.user_name}} <br/>
              {{scope.row.real_name}} <br/>
            </template>
          </el-table-column>
          <el-table-column prop="role.role_name" label="所属角色">
            <template slot-scope="scope">
              <div v-if="scope.row.is_super == 0">
                <span class="mr10 green" v-for="(item, index) in scope.row.userRole" :key="index">{{ item.role.role_name }}</span>
              </div>
              <div class="gray" v-if="scope.row.is_super == 1">
                超级管理员
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
               <el-button v-if="scope.row.is_super < 1 && hasBusinessRole(scope.row)" @click="addsupplyClick(scope.row)" type="text" size="small" >鲜花商家</el-button>
              <el-button v-if="scope.row.is_super < 1" @click="editClick(scope.row)" type="text" size="small" v-auth="'/auth/user/edit'">编辑</el-button>
              <el-button v-if="scope.row.is_super < 1" @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/auth/user/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open="open_add" :roleList="roleList"  @close="closeAdd"></Add>

    <Edit :open="open_edit" :roleList="roleList" :shop_user_id="curModel.shop_user_id"  @close="closeEdit"></Edit>

    <!-- 新增鲜花驿站商家弹窗 -->
    <AddSupply :open="open_add_supply" :roleList="supplyRoleList" :shop_user_id="curModel.shop_user_id" @close="closeAddSupply"></AddSupply>

  </div>
</template>

<script>
import AuthApi from '@/api/auth.js';
import Add from './dialog/Add.vue';
import Edit from './dialog/Edit.vue';
import AddSupply from './dialog/AddSupply.vue'; // 新增组件
import CouponUsedLogVue from '../../plus/coupon/coupon/CouponUsedLog.vue';
export default {
  components: {
    Add,
    Edit,
    AddSupply
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*角色是否加载完成*/
      role_loading:true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user_name: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*是否打开鲜花驿站商家弹窗*/
      open_add_supply: false,
      /*当前编辑的对象*/
      curModel: {},
      /*角色列表*/
      roleList:[],
      /*鲜花商家角色列表*/
      supplyRoleList: [],
      /*商家角色ID*/
      businessRoleId: null,
      /*鲜花商家角色ID*/
      flowerRoleId: null
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();

    this.getAllrole();
  },
  methods: {
    /*检查用户是否有商家角色（排除鲜花商家）*/
    hasBusinessRole(row) {
      if (!row.userRole || !row.userRole.length) return false;
      
      // 查找商家角色，但排除鲜花商家角色
      const hasBusiness = row.userRole.some(userRole => 
        userRole.role && 
        userRole.role.role_name.includes('商家') && 
        !userRole.role.role_name.includes('鲜花') &&
        userRole.role.role_id !== this.flowerRoleId
      );
      
      return hasBusiness;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList(searchParams='') {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      if(searchParams!=''){
        Params.user_name = searchParams;
      }
      AuthApi.userList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*获取角色*/
    getAllrole() {
      let self = this;
      AuthApi.userAddInfo()
        .then(data => {
          self.role_loading = false;
          self.roleList = data.data.roleList;
          
          // 过滤出鲜花商家角色
          self.supplyRoleList = data.data.roleList.filter(role => 
            role.role_name.includes('鲜花') || 
            role.role_name.includes('商家') ||
            role.role_name.includes('驿站')
          );
          
          // 如果没有找到相关角色，使用全部角色
          if (self.supplyRoleList.length === 0) {
            self.supplyRoleList = [...data.data.roleList];
          }
          
          // 查找商家角色ID（排除鲜花商家）
          const businessRole = data.data.roleList.find(role => 
            role.role_name.includes('商家') && !role.role_name.includes('鲜花')
          );
          if (businessRole) {
            self.businessRoleId = businessRole.role_id;
          }
          
          // 查找鲜花商家角色ID
          const flowerRole = data.data.roleList.find(role => 
            role.role_name.includes('鲜花')
          );
          if (flowerRole) {
            self.flowerRoleId = flowerRole.role_id;
          }
        })
        .catch(error => {
          self.role_loading = false;
        });
    },
    
    /*打开鲜花驿站商家弹窗*/
    addsupplyClick(row) {
      if(!this.role_loading){
        this.curModel = row;
        this.open_add_supply = true;
      }
    },
    
    /*关闭鲜花驿站商家弹窗*/
    closeAddSupply(e){
      this.open_add_supply = false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let searchParams = self.formInline.user_name;
      self.getTableList(searchParams);
    },

    /*打开添加*/
    addClick() {
      if(!this.role_loading){
         this.open_add=true;
      }
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*打开编辑*/
    editClick(row) {
      this.curModel=row;
      this.open_edit=true;
    },

    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          AuthApi.userDelete(
            {
              shop_user_id: row.shop_user_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，该管理员删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/auth/user/index.vue